import { useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import { PageLayout, Pagination } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ExpandableList } from 'ui/expandableList/ExpandableList';
import { DefinitionsBar } from '../definitionsBar/DefinitionsBar';

import { PassagesProps, PassagesServer } from './Passages.types';
import { PassagesListContainer } from './passagesList/PassagesListContainer';

export const Passages = ({
  servers,
  zones,
  isLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  isAddDisabled,
  addDisabledReason,
  isDeleteDisabled,
  deleteDisabledReason,
}: PassagesProps) => {
  const { formatMessage } = useLocale();
  const [passagesCount, setPassagesCount] = useState(0);
  const [expandedServer, setExpandedServer] = useState<PassagesServer>();

  const serverItems = useMemo(() => servers.map((server) => ({ ...server, id: server.rcpId })), [servers]);

  return (
    <PageLayout
      header={formatMessage({ id: AppMessages['definitions.title'] })}
      renderContent={() => (
        <>
          <DefinitionsBar
            addPassageProps={{
              servers,
              zones,
              defaultServerId: expandedServer?.rcpId,
              isDisabled: isAddDisabled,
              disabledReason: addDisabledReason,
            }}
          />

          <Pagination
            page={page}
            setPage={setPage}
            count={passagesCount}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />

          {/* Only one server is expanded at a time; pagination applies within it (Confluence 12. Przejścia, pkt 3–4). */}
          <ExpandableList
            data={serverItems}
            isLoading={isLoading}
            nothingToShowText={formatMessage({ id: AppMessages['devices.nothingToShow'] })}
            title={(server) => <Typography variant="h6">{server.nazwaRcp}</Typography>}
            initiallyExpandedItem={serverItems[0]}
            toggleItemExpansion={(server) => {
              setExpandedServer(server);
              if (!server) setPassagesCount(0);
            }}
            onClickExpandButton={() => {
              setPage(0);
            }}
            renderExpandableItemBody={(server, expanded) =>
              expanded?.id === server.id ? (
                <PassagesListContainer
                  server={server}
                  setPassagesCount={setPassagesCount}
                  isDeleteDisabled={isDeleteDisabled}
                  deleteDisabledReason={deleteDisabledReason}
                />
              ) : null
            }
          />
        </>
      )}
    />
  );
};
